import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { styled } from '@stitches/react';
import { useTranslation } from 'react-i18next';
import AnimatedSection from '../../components/common/AnimatedSection';

// 导入新闻资讯子页面
import NewsOverview from './NewsOverview';
import NewsDetail from './NewsDetail';

// 样式组件
const BlogPageContainer = styled('div', {
  padding: '40px 0',
  maxWidth: '1200px',
  margin: '0 auto',
  
  '@media (max-width: 768px)': {
    padding: '20px',
  }
});

const BlogHeader = styled('div', {
  textAlign: 'center',
  marginBottom: '60px',

  '& h1': {
    fontSize: '42px',
    fontWeight: '700',
    marginBottom: '20px',
    color: '$headingColor',

    '@media (max-width: 768px)': {
      fontSize: '36px',
    }
  },

  '& p': {
    fontSize: '18px',
    color: '$textSecondary',
    maxWidth: '700px',
    margin: '0 auto',
    lineHeight: '1.6',
  }
});

// 博客页面组件
const NewsPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <BlogPageContainer>
      <AnimatedSection direction="down">
        <BlogHeader>
          <h1>{t('blog.title')}</h1>
          <p>{t('blog.subtitle')}</p>
        </BlogHeader>
      </AnimatedSection>

      {/* 博客路由 */}
      <Routes>
        <Route index element={<NewsOverview />} />
        <Route path=":id" element={<NewsDetail />} />
      </Routes>
    </BlogPageContainer>
  );
};

export default NewsPage; 